import { themeGet } from '@styled-system/theme-get'
import { Box, Card, Divider } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import CardImage from './sections/CardImage'
import PackageSection from './sections/PackageSection'
import PriceRow from './sections/PriceRow'

const HoverBox = styled(Box)`
  &:hover {
    cursor: pointer;
    box-shadow: ${themeGet('shadows.xl')};
  }
`

function PackageListingCard({
  currencySymbol,
  heading,
  headingColor,
  headingTextStyle,
  imageUrl,
  maxWidth = 390,
  packagesBadge,
  packageSectionProps,
  price,
  priceBadge,
  priceType,
  savingsDisplay,
  strikePrice,
  handleClick,
}) {
  const cardImageProps = {
    badgeText: packagesBadge,
    heading,
    headingColor,
    headingTextStyle,
    imageUrl,
  }

  const priceRowProps = {
    currencySymbol,
    price,
    priceBadge,
    priceType,
    savingsDisplay,
    strikePrice,
  }

  return (
    <HoverBox borderRadius='xl' boxShadowSize='md' minWidth={280} maxWidth={maxWidth} onClick={handleClick}>
      <Card borderRadius='xl' borderWidth={0}>
        {imageUrl && <CardImage {...cardImageProps} />}
        <Box pt={2} px={2}>
          <PackageSection
            packagesBadge={packagesBadge}
            hasImage={Boolean(imageUrl)}
            productProps={packageSectionProps}
          />
        </Box>
        <Divider />
        <Box borderRadius='xl' rounded='bottom'>
          <PriceRow {...priceRowProps} />
        </Box>
      </Card>
    </HoverBox>
  )
}

export default PackageListingCard
